<template>
</template>

<script>
export default {
  name: "Cancel",
  mounted() {
      this.$store.dispatch("social_login", {
        token: this.$route.params.id
      });
  },
  
};
</script>

<style scoped>
.toggle-switch label {
  line-height: 1.4 !important;
}
.person_icon {
  width: 90px;
  margin-bottom: 10px;
  cursor: pointer;
}
.big.person_icon {
  width: 130px;
}
.card {
  margin: auto;
  margin-top: 5em;
  box-shadow: 1.5px 1px 10px rgba(228, 229, 247, 0.5);
}
.alert {
  margin-top: 1em;
  margin-left: 5em;
  margin-right: 5em;
  max-width: 40rem;
}
.image {
  background-color: rgb(255, 255, 255);
  border: none;
  border-radius: 50%;
}
.but {
  margin-top: 10px;
  background-color: none;
  color: none;
  border: none;
}

.welcome {
  font-family: "Roboto", sans-serif;
  font-style: bold;
  font-weight: 500;
  font-size: 33px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.name input {
  margin-bottom: 10px;
}
</style>